/**
 * @generated SignedSource<<2b4816432f9e7c4ab0cd944b04ac6e13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage$data = {
  readonly id: string;
  readonly routines: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentageRoutineItem_routine">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage";
};
export type WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage$key = {
  readonly " $data"?: WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routines",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetRoutinePositivePercentageRoutineItem_routine"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetRoutinePositivePercentage",
  "abstractKey": null
};
})();

(node as any).hash = "b7dba7b129302752b4ef594fc97d8bc4";

export default node;
